/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScreeningEvent
 */
export interface InternalApiScreeningEvent {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScreeningEvent
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScreeningEvent
     */
    createdTime?: Date;
}

/**
 * Check if a given object implements the InternalApiScreeningEvent interface.
 */
export function instanceOfInternalApiScreeningEvent(value: object): value is InternalApiScreeningEvent {
    return true;
}

export function InternalApiScreeningEventFromJSON(json: any): InternalApiScreeningEvent {
    return InternalApiScreeningEventFromJSONTyped(json, false);
}

export function InternalApiScreeningEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
    };
}

export function InternalApiScreeningEventToJSON(json: any): InternalApiScreeningEvent {
    return InternalApiScreeningEventToJSONTyped(json, false);
}

export function InternalApiScreeningEventToJSONTyped(value?: InternalApiScreeningEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
    };
}

